import Joi from 'joi-browser';
import { customValidateDate } from '../../../utilities/validateDateUtil';

import regex from '../../../utilities/validateRegex';

/**
 * バリデーション用のスキーマを作成する
 * @return {object} スキーマオブジェクト
 * */
const createValidateSchema = () => {
  const schema = Object.create(null);

  // 視力 左右
  const visualAcuitySchema = Joi.string()
    .regex(regex.pattern.numberNoSign)
    .allow(null, '');
  schema.visual_acuity_left = visualAcuitySchema;
  schema.visual_acuity_right = visualAcuitySchema;
  schema.pneumoconiosis_visual_acuity_left = Joi.when('showPneumoconiosis', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.pneumoconiosis_visual_acuity_right = Joi.when('showPneumoconiosis', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.asbestos_visual_acuity_left = Joi.when('showAsbestos', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.asbestos_visual_acuity_right = Joi.when('showAsbestos', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.organic_solvent_visual_acuity_left = Joi.when('showOrganicSolvent', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.organic_solvent_visual_acuity_right = Joi.when('showOrganicSolvent', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.specific_chemicals_visual_acuity_left = Joi.when(
    'showSpecificChemicals',
    {
      is: true,
      then: visualAcuitySchema,
    }
  );
  schema.specific_chemicals_visual_acuity_right = Joi.when(
    'showSpecificChemicals',
    {
      is: true,
      then: visualAcuitySchema,
    }
  );
  schema.ionization_visual_acuity_left = Joi.when('showIonization', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.ionization_visual_acuity_right = Joi.when('showIonization', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.vibration_disease_visual_acuity_left = Joi.when(
    'showVibrationDisease',
    {
      is: true,
      then: visualAcuitySchema,
    }
  );
  schema.vibration_disease_visual_acuity_right = Joi.when(
    'showVibrationDisease',
    {
      is: true,
      then: visualAcuitySchema,
    }
  );
  schema.high_pressure_visual_acuity_left = Joi.when('showHighPressure', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.high_pressure_visual_acuity_right = Joi.when('showHighPressure', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.lead_visual_acuity_left = Joi.when('showLead', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.lead_visual_acuity_right = Joi.when('showLead', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.tetraalkyl_lead_visual_acuity_left = Joi.when('showTetraalkylLead', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.tetraalkyl_lead_visual_acuity_right = Joi.when('showTetraalkylLead', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.decontamination_visual_acuity_left = Joi.when('showDecontamination', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.decontamination_visual_acuity_right = Joi.when('showDecontamination', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.dental_visual_acuity_left = Joi.when('showDental', {
    is: true,
    then: visualAcuitySchema,
  });
  schema.dental_visual_acuity_right = Joi.when('showDental', {
    is: true,
    then: visualAcuitySchema,
  });

  // 血圧 上下
  const bpShema = Joi.string()
    .regex(regex.pattern.integerNoSign)
    .allow(null, '');
  schema.high_bp = bpShema;
  schema.low_bp = bpShema;
  schema.pneumoconiosis_high_bp = Joi.when('showPneumoconiosis', {
    is: true,
    then: bpShema,
  });
  schema.pneumoconiosis_low_bp = Joi.when('showPneumoconiosis', {
    is: true,
    then: bpShema,
  });
  schema.asbestos_high_bp = Joi.when('showAsbestos', {
    is: true,
    then: bpShema,
  });
  schema.asbestos_low_bp = Joi.when('showAsbestos', {
    is: true,
    then: bpShema,
  });
  schema.organic_solvent_high_bp = Joi.when('showOrganicSolvent', {
    is: true,
    then: bpShema,
  });
  schema.organic_solvent_low_bp = Joi.when('showOrganicSolvent', {
    is: true,
    then: bpShema,
  });
  schema.specific_chemicals_high_bp = Joi.when('showSpecificChemicals', {
    is: true,
    then: bpShema,
  });
  schema.specific_chemicals_low_bp = Joi.when('showSpecificChemicals', {
    is: true,
    then: bpShema,
  });
  schema.ionization_high_bp = Joi.when('showIonization', {
    is: true,
    then: bpShema,
  });
  schema.ionization_low_bp = Joi.when('showIonization', {
    is: true,
    then: bpShema,
  });
  schema.vibration_disease_high_bp = Joi.when('showVibrationDisease', {
    is: true,
    then: bpShema,
  });
  schema.vibration_disease_low_bp = Joi.when('showVibrationDisease', {
    is: true,
    then: bpShema,
  });
  schema.high_pressure_high_bp = Joi.when('showHighPressure', {
    is: true,
    then: bpShema,
  });
  schema.high_pressure_low_bp = Joi.when('showHighPressure', {
    is: true,
    then: bpShema,
  });
  schema.lead_high_bp = Joi.when('showLead', {
    is: true,
    then: bpShema,
  });
  schema.lead_low_bp = Joi.when('showLead', {
    is: true,
    then: bpShema,
  });
  schema.tetraalkyl_lead_high_bp = Joi.when('showTetraalkylLead', {
    is: true,
    then: bpShema,
  });
  schema.tetraalkyl_lead_low_bp = Joi.when('showTetraalkylLead', {
    is: true,
    then: bpShema,
  });
  schema.decontamination_high_bp = Joi.when('showDecontamination', {
    is: true,
    then: bpShema,
  });
  schema.decontamination_low_bp = Joi.when('showDecontamination', {
    is: true,
    then: bpShema,
  });
  schema.dental_high_bp = Joi.when('showDental', {
    is: true,
    then: bpShema,
  });
  schema.dental_low_bp = Joi.when('showDental', {
    is: true,
    then: bpShema,
  });

  const dateSchema = customValidateDate.base().validateDate();
  schema.medical_examination_date = dateSchema;
  schema.special_medical_examination_date = dateSchema;
  schema.special_medical_examination_date_asbestos = Joi.when('showAsbestos', {
    is: true,
    then: dateSchema,
  });
  schema.special_medical_examination_date_ionization = Joi.when(
    'showIonization',
    {
      is: true,
      then: dateSchema,
    }
  );
  schema.special_medical_examination_date_organic_solvent = Joi.when(
    'showOrganicSolvent',
    {
      is: true,
      then: dateSchema,
    }
  );
  schema.special_medical_examination_date_pneumoconiosis = Joi.when(
    'showPneumoconiosis',
    {
      is: true,
      then: dateSchema,
    }
  );
  schema.special_medical_examination_date_vibration_disease = Joi.when(
    'showVibrationDisease',
    {
      is: true,
      then: dateSchema,
    }
  );
  schema.special_medical_examination_date_specific_chemicals = Joi.when(
    'showSpecificChemicals',
    {
      is: true,
      then: dateSchema,
    }
  );
  schema.special_medical_examination_date_high_pressure = Joi.when(
    'showHighPressure',
    {
      is: true,
      then: dateSchema,
    }
  );
  schema.special_medical_examination_date_lead = Joi.when('showLead', {
    is: true,
    then: dateSchema,
  });
  schema.special_medical_examination_date_tetraalkyl_lead = Joi.when(
    'showTetraalkylLead',
    {
      is: true,
      then: dateSchema,
    }
  );
  schema.special_medical_examination_date_decontamination = Joi.when(
    'showDecontamination',
    {
      is: true,
      then: dateSchema,
    }
  );
  schema.special_medical_examination_date_dental = Joi.when('showDental', {
    is: true,
    then: dateSchema,
  });

  return schema;
};

/**
 * 健康診断更新用リクエストパラメータを作成する
 * @param {object} data 作成元データ
 * @return {object} リクエストパラメータ
 * */
const createUpdateMedicalExaminationParam = data => {
  return {
    worker_medical_examinations: data,
    worker_special_medical_examinations: data,
  };
};

const createSafetyDocItemSchema = () => {
  const schema = {
    medical_examination_date: customValidateDate
      .base()
      .validateDate()
      .requiredDate(),
    high_bp: Joi.string()
      .regex(regex.pattern.integerNoSign)
      .required(),
    low_bp: Joi.string()
      .regex(regex.pattern.integerNoSign)
      .required(),
    special_medical_examination_date_pneumoconiosis: Joi.when(
      'showPneumoconiosis',
      {
        is: true,
        then: customValidateDate
          .base()
          .validateDate()
          .requiredDate(),
      }
    ),
    special_medical_examination_date_asbestos: Joi.when('showAsbestos', {
      is: true,
      then: customValidateDate
        .base()
        .validateDate()
        .requiredDate(),
    }),
    special_medical_examination_date_organic_solvent: Joi.when(
      'showOrganicSolvent',
      {
        is: true,
        then: customValidateDate
          .base()
          .validateDate()
          .requiredDate(),
      }
    ),
    special_medical_examination_date_specific_chemicals: Joi.when(
      'showSpecificChemicals',
      {
        is: true,
        then: customValidateDate
          .base()
          .validateDate()
          .requiredDate(),
      }
    ),
    special_medical_examination_date_ionization: Joi.when('showIonization', {
      is: true,
      then: customValidateDate
        .base()
        .validateDate()
        .requiredDate(),
    }),
    special_medical_examination_date_vibration_disease: Joi.when(
      'showVibrationDisease',
      {
        is: true,
        then: customValidateDate
          .base()
          .validateDate()
          .requiredDate(),
      }
    ),
    special_medical_examination_date_high_pressure: Joi.when(
      'showHighPressure',
      {
        is: true,
        then: customValidateDate
          .base()
          .validateDate()
          .requiredDate(),
      }
    ),
    special_medical_examination_date_lead: Joi.when('showLead', {
      is: true,
      then: customValidateDate
        .base()
        .validateDate()
        .requiredDate(),
    }),
    special_medical_examination_date_tetraalkyl_lead: Joi.when(
      'showTetraalkylLead',
      {
        is: true,
        then: customValidateDate
          .base()
          .validateDate()
          .requiredDate(),
      }
    ),
    special_medical_examination_date_decontamination: Joi.when(
      'showDecontamination',
      {
        is: true,
        then: customValidateDate
          .base()
          .validateDate()
          .requiredDate(),
      }
    ),
    special_medical_examination_date_dental: Joi.when('showDental', {
      is: true,
      then: customValidateDate
        .base()
        .validateDate()
        .requiredDate(),
    }),
  };
  return schema;
};

const MedicalExaminationService = {
  createValidateSchema,
  createUpdateMedicalExaminationParam,
  createSafetyDocItemSchema,
};

export default MedicalExaminationService;



// WEBPACK FOOTER //
// ./src/services/workers/medicalExamination/MedicalExaminationService.js